import { useState, useRef, useEffect } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { authUser } from './actions';
import loginSuccess from '../../../media/lottie/check-mark-success-animation.json';
import { MainButton } from '../../gui/input/MainButton';
import { Container } from '../../gui/layout/Container';
import { StyledLoginForm, StyledLottie } from './Style';
import { IconEyeNoLock, WhistLawLongLogo } from '../../../App/theme/icons';

import image1 from '../../../media/img/loginphoto1.png';
import image2 from '../../../media/img/loginphoto2.png';
import image3 from '../../../media/img/loginphoto3.png';
import { GridRow } from '../../gui/layout/GridRow';

import { IconLock } from '../../../App/theme/icons';

import { useFormik } from 'formik';
import * as yup from 'yup';
import PasswordAndConfirmPasswordValidation from './PasswordValidation/PasswordAndConfirmPasswordValidation';

export default function LoginPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [verifyingLogin, setVerifyingLogin] = useState(false);
  const [loginError, setLoginError] = useState('');
  const [showLoginSucess, setShowLoginSuccess] = useState(false);
  const [passwordLockView, setPasswordLockView] = useState(true);

  const myInput = useRef();

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },

    validationSchema: yup.object({
      email: yup.string().email().required(),
      password: yup.string().min(6).max(20).required(),
    }),

    onSubmit: async (values) => {
      setLoginError('');
      try {
        let data = await dispatch(authUser(values));
        navigate('/');
      } catch (err) {
        setLoginError(err.message);
      }
    },
  });

  const handleSetPasswordLockView = () => {
    if (myInput.current.getAttribute('type') === 'password') {
      setPasswordLockView(false);
      myInput.current.setAttribute('type', 'text');
    } else {
      setPasswordLockView(true);
      myInput.current.setAttribute('type', 'password');
    }
  };

  return (
    <StyledLoginForm>
      <Container width="90%">
        <GridRow colTemplate="3fr 2fr">
          <div className="left-side-column">
            <WhistLawLongLogo width="350px" />
            <div className="images-container">
              <img src={image1} alt="" />
              <img src={image2} alt="" />
              <img src={image3} alt="" />
            </div>
          </div>
          <div className="formContainer">
            <div>
              <div className="inputHolder">
                <h3>Sign in</h3>
                <p className="subtitle">Enter your credentials to continue.</p>

                <form onSubmit={formik.handleSubmit}>
                  <div className="form-group">
                    <label>Email Address</label>
                    <div className={`formInput ${formik.touched.email && formik.errors.email ? 'error' : ''}`}>
                      <input type="text" name="email" placeholder="Email Address" onChange={formik.handleChange} value={formik.values.email} onBlur={formik.handleBlur} />
                    </div>
                    {formik.touched.email && formik.errors.email && (
                      <p className="error-message">
                        {/* {formik.errors.email} */}
                        This field is required
                      </p>
                    )}
                  </div>

                  <div className="form-group">
                    <label>Password</label>
                    <div className={`formInput ${formik.touched.password && formik.errors.password ? 'error' : ''}`}>
                      {/* <PasswordAndConfirmPasswordValidation withConfirmPassword={false} /> */}
                      <input ref={myInput} type="password" name="password" placeholder="Password" onChange={formik.handleChange} value={formik.values.password} onBlur={formik.handleBlur} />
                      {passwordLockView ? <IconLock className="pointer" onClick={() => handleSetPasswordLockView()} /> : <IconEyeNoLock className="pointer" onClick={() => handleSetPasswordLockView()} />}
                    </div>
                    <br />
                    {/* {formik.touched.password && formik.errors.password && <p style={{ color: 'red' }}>{formik.errors.password}</p>} */}
                    {formik.touched.password && formik.errors.password && <p className="error-message password">This field is required</p>}
                  </div>

                  <MainButton width="100%">Login to Continue</MainButton>

                  <div className="buttonHolder">
                    {loginError !== '' && <span className="loginError">{loginError}</span>}

                    <p className="forgot-password-text">
                      Forgot password?{' '}
                      <Link to="/forgot-password" className="bold blue">
                        Reset here
                      </Link>
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </GridRow>
      </Container>
    </StyledLoginForm>
  );
}
